"use strict";
module.exports = require('../../module.compiled').vendored['react-rsc'].ReactServerDOMWebpackServer;

//# sourceMappingURL=react-server-dom-webpack-server.js.map